module.exports = __webpack_public_path__ + "img/get-expatex.aa048430.png";